export default "__VITE_ASSET__CkEvg1YW__"